var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vgsi-slide-item",
      style: { backgroundImage: "url(" + _vm.propSlide.slide_bg + ")" }
    },
    [
      _c("div", { staticClass: "vgsi-slide-content__wrap" }, [
        _c("div", { staticClass: "vgsi-slide-content__box" }, [
          _c("h6", { staticClass: "vgsi-slide-content__sub-title" }, [
            _vm._v("Our Solution")
          ]),
          _vm._v(" "),
          _c("h2", { staticClass: "vgsi-slide-content__title" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.propSlide.slide_title) + "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "vgsi-slide-content__desc" }, [
            _vm._v(_vm._s(_vm.propSlide.description))
          ]),
          _vm._v(" "),
          _vm.propSlide.button_is_active
            ? _c("div", {
                class: _vm.renderClass(_vm.propSlide.button_class),
                domProps: { innerHTML: _vm._s(_vm.propSlide.button_link) }
              })
            : _vm._e()
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }